// extracted by mini-css-extract-plugin
export var aboveInput = "_fs-0";
export var actionButton = "_fs-5";
export var actionButtonContainer = "_fs-1";
export var actionIcon = "_fs-6";
export var aiInfoContainer = "_fs-2";
export var attachmentWrapper = "_fs-7";
export var bold = "_fs-3";
export var checkIcon = "_fs-8";
export var clickingRecipientBar = "_fs-11";
export var commentThreadSwitch = "_fs-a";
export var draftImage = "_fs-b";
export var draftImageContainer = "_fs-c";
export var draftImages = "_fs-e";
export var editButton = "_fs-g";
export var editor = "_fs-f";
export var editorContainer = "_fs-y";
export var editorErrorTooltipWrapper = "_fs-9";
export var headerDivider = "_fs-h";
export var icon = "_fs-i";
export var info = "_fs-j";
export var internal = "_fs-n";
export var internalDivider = "_fs-k";
export var internalMessage = "_fs-l";
export var messageInputCard = "_fs-m";
export var messageInputForm = "_fs-o";
export var messageInputFormInternal = "_fs-p";
export var options = "_fs-q";
export var publicMessageCustomer = "_fs-s";
export var publicMessageMerchant = "_fs-r";
export var removeImageButton = "_fs-d";
export var replyButtons = "_fs-t";
export var showSignatureButton = "_fs-u";
export var spinner = "_fs-v";
export var verticalButtonDivider = "_fs-4";
export var visibilitySelector = "_fs-w";
export var warning = "_fs-x";
export var wrappingText = "_fs-z";
export var writingInternalNoteTopBorder = "_fs-10";